import React, { useState, useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import PublicShell from '../components/PublicShell';



const Register = () => {

  const [form, setForm] = useState({

    username: '',

    email: '',

    password: '',

    confirmPassword: '',

  });

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false);

  const { register, isAuthenticated } = useAuth();

  const navigate = useNavigate();



  useEffect(() => {

    if (isAuthenticated) navigate('/uebersicht', { replace: true });

  }, [isAuthenticated, navigate]);



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    setError('');



    if (form.password !== form.confirmPassword) {

      setError('Passwörter stimmen nicht überein.');

      setLoading(false);

      return;

    }

    if (form.password.length < 6) {

      setError('Passwort muss mindestens 6 Zeichen lang sein.');

      setLoading(false);

      return;

    }



    if (!acceptTerms) {
      setError('Bitte akzeptiere die Teilnahmebedingungen und Datenschutzerklärung.');
      setLoading(false);
      return;
    }

    const result = await register(form.username, form.email, form.password);

    if (result.success) {

      navigate('/login', { state: { message: 'Registrierung erfolgreich! Bitte melde dich an.' } });

    } else {

      setError(result.error);

    }

    setLoading(false);

  };



  return (

    <PublicShell narrow>

      <div className="auth-card">

        <span className="t12-badge">Tippspiel</span>

        <h1 className="section-title text-2xl md:text-3xl mb-1">Registrierung</h1>

        <p className="text-sm text-white/50 mb-6">

          Erstelle dein Konto – nur so können wir deine Tipps speichern und werten.

        </p>

        {error && <div className="alert-error-dark mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">

          <div>

            <label className="label-dark" htmlFor="username">Benutzername</label>

            <input

              id="username"

              className="input-dark"

              value={form.username}

              onChange={(e) => setForm({ ...form, username: e.target.value })}

              required

            />

          </div>

          <div>

            <label className="label-dark" htmlFor="email">E-Mail</label>

            <input

              id="email"

              type="email"

              className="input-dark"

              value={form.email}

              onChange={(e) => setForm({ ...form, email: e.target.value })}

              required

            />

          </div>

          <div>

            <label className="label-dark" htmlFor="password">Passwort</label>

            <input

              id="password"

              type="password"

              className="input-dark"

              value={form.password}

              onChange={(e) => setForm({ ...form, password: e.target.value })}

              minLength={6}

              required

            />

          </div>

          <div>

            <label className="label-dark" htmlFor="confirm">Passwort bestätigen</label>

            <input

              id="confirm"

              type="password"

              className="input-dark"

              value={form.confirmPassword}

              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}

              required

            />

          </div>
          <label className="flex items-start gap-3 text-sm text-white/60 cursor-pointer">
            <input
              type="checkbox"
              className="admin-checkbox mt-0.5"
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
              required
            />
            <span>
              Ich akzeptiere die{' '}
              <Link to="/teilnahmebedingungen" className="text-primary-light hover:underline" target="_blank">
                Teilnahmebedingungen
              </Link>
              {' '}und die{' '}
              <Link to="/datenschutz" className="text-primary-light hover:underline" target="_blank">
                Datenschutzerklärung
              </Link>.
            </span>
          </label>
          <button type="submit" className="btn-wacker w-full" disabled={loading}>

            {loading ? 'Registrieren…' : 'Konto erstellen'}

          </button>

        </form>

        <p className="text-center text-sm mt-6 text-white/50">

          Bereits registriert?{' '}

          <Link to="/login" className="text-primary-light hover:underline font-semibold">Anmelden</Link>

        </p>

        <p className="text-center text-sm mt-2">

          <Link to="/" className="text-white/40 hover:text-white/70 text-xs">← Zur Startseite</Link>

        </p>

      </div>

    </PublicShell>

  );

};



export default Register;


